import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m7dq6epgxj: FaireBrandEntity = {
  token: "b_m7dq6epgxj",
  type: "brand",
  name: "Figment Kombucha",
  avatarUrl:
    "https://cdn.faire.com/fastly/e3fd89c17187dd878501b43a6742b8b7ba59ac0fe0ca999ed5737170abbbdbd2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b9d9dfbe8b70dd41b4909b60e5f0ff16f1bf4c4427a11d620b7355a851c66442.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e3fd89c17187dd878501b43a6742b8b7ba59ac0fe0ca999ed5737170abbbdbd2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b9d9dfbe8b70dd41b4909b60e5f0ff16f1bf4c4427a11d620b7355a851c66442.png",
  location: "Athens, GA, USA",
  minimumOrderDollars: 999,
  rating: 5,
  reviewCount: 28,
  isTopShop: true,
  isInsider: true,
  description:
    "We’re proud to be different.\n\nAt Figment Kombucha we do things differently, and our customers agree: you may have tried the national kombucha brands available in your local grocery store, but until you’ve tried Figment Kombucha, you don’t know what you’re missing.\n\nInnovative flavors, local seasonal ingredients and a unique focus on sustainable business practices results in some of the finest kombucha made today. Just because something tastes good doesn’t mean it has to be harmful to your health or the health of our planet, and Figment kombucha is here to change the way we think about canned beverages.\n\nWe view becoming a 1% for the Planet® member as an investment in ethical business and the future of our planet. As a business member of 1% for the Planet, we pledge to give 1% of all sales to environmental causes. Why 1% of sales? For businesses of any size, 1% of sales—not just profits—is a real and substantial commitment. Currently, only 3% of philanthropic giving goes to the environment. Our planet needs more support and the 1% for the Planet network is on a mission to change that.1% for the Planet provides personalized giving strategies and forges powerful partnerships between businesses, individuals and environmental nonprofits to ensure the most impact possible.\n\nTake the Figment challenge today, even if you think you don’t like kombucha, we’ll bet you do once you try ours.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.532Z",
    importedBy: "entity-db-cli",
  },
};
